module.exports = __webpack_public_path__ + "static/media/tag3.409cad74.svg";